"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.restoreErrorSelector = restoreErrorSelector;
exports.restoreStatusSelector = restoreStatusSelector;
exports.viewStateEmailSelector = viewStateEmailSelector;
var _validation = require("../../../../utils/validation");
function viewStateEmailSelector(state) {
  const {
    data: viewData
  } = state.view;
  if (viewData && viewData.email) {
    return viewData.email;
  } else if (state.login && (0, _validation.isEmail)(state.login)) {
    return state.login;
  }
  return '';
}
function restoreErrorSelector(state) {
  return state.authentication.restore.error;
}
function restoreStatusSelector(state) {
  return state.authentication.restore.status;
}